import focusLock from 'dom-focus-lock';
import { setScrollbarWidthOnDocument } from '../../functions/setScrollbarWidthOnDocument';
import { toggleAriaHiddenOnBodyChildren } from '../../functions/toggleAriaHiddenOnBodyChildren';
export default function toggleSearch(close) {
    const searchModal = document.querySelector('#header-search');
    const searchButton = document.querySelector('#header-search-button');
    const header = document.querySelector('.spv-header');
    const shellHeader = document.querySelector('#spv-shell-header');
    if (!searchModal || !searchButton || !header)
        return;
    function syncHeight() {
        document.documentElement.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
    }
    function closeSearchModal() {
        searchModal?.classList.remove('spv-headerSearch--open');
        header?.classList.remove('spv-header--searchIsOpen');
        searchButton?.setAttribute('aria-expanded', 'false');
        window.removeEventListener('keyup', escapeEvent);
        toggleAriaHiddenOnBodyChildren(shellHeader, 'off');
        setScrollbarWidthOnDocument();
        if (!close) {
            focusLock.off(header);
            document.documentElement.classList.remove('spv-scrollLock');
            searchButton.focus();
        }
    }
    function openSearchModal() {
        toggleAriaHiddenOnBodyChildren(shellHeader, 'on');
        setScrollbarWidthOnDocument();
        document.documentElement.classList.add('spv-scrollLock');
        searchModal?.classList.add('spv-headerSearch--open');
        header?.classList.add('spv-header--searchIsOpen');
        searchButton?.setAttribute('aria-expanded', 'true');
        window.addEventListener('keyup', escapeEvent);
        focusLock.on(header);
        searchModal.querySelector('input')?.focus();
        syncHeight();
    }
    function escapeEvent(event) {
        if (event.defaultPrevented) {
            return;
        }
        const key = event.key || event.code;
        if (key === 'Escape' || key === 'Esc' || key === '27') {
            closeSearchModal();
        }
    }
    if (searchModal?.classList.contains('spv-headerSearch--open') || close) {
        closeSearchModal();
    }
    else {
        openSearchModal();
    }
}
//# sourceMappingURL=toggleSearch.js.map